import {
    _getElStyle,
    _showClearIcon,
    _getInputElStyle,
    _showValidationError,
    goRangeClearInputIcon,
    _removeValidationInfo,
    _hideClearIcon,
    _showErrorToolTip,
    _hideErrorToolTip,
    _clearInputVal
} from "./Common_Fun";
import CommonInputCtl from './js-input';


window._showErrorToolTip=_showErrorToolTip;
window._hideErrorToolTip=_hideErrorToolTip;
window._clearInputVal=_clearInputVal;


import {AssertUtils} from "goingutils";
let NumberInputCtl = {
    /**
     * 获取控件的html
     * @param formType 表单类型 分查询表单 和普通表单
     * @param item 选项
     * @param targetObj 可能是GoingForm对象 也可能是QueryForm对象
     */
    getHtml: function (formType, item, targetObj) {
        if (formType === "singleQuery") {
            return this.getSingleQueryHtml(item, targetObj);
        } else if (formType === "query") {
            return this.getQueryHtml(item, targetObj);
        } else {
            item.extendClass="go-number-input";
            return CommonInputCtl.getEditorHtml(item, targetObj,'number');
        }
    },
    //获取显示值
    getShowValue(curVal) {
        return curVal;
    },
    /**
     * 获取编辑模式下的html代码
     * @param item
     * @param targetObj
     * @returns {string}
     */
    getSingleQueryHtml: function ({label, id, required}, targetObj) {
        return `  <div class="go-content clearfix">
                     <div class="input-group pull-left" style="cursor: pointer;margin-right:4px;">
                        <input style="width: 80px;border: none;height:25px;" id="${
            targetObj.prefixCls
            }_${id}_start" type="number" class="go-number-input form-control padding-l-bs">
                         ${goRangeClearInputIcon(targetObj, id, "start")} 
                     </div>
                     <div class="pull-left" style="line-height: 26px;height: 25px;">至</div>
                     <div class="input-group  pull-left" style="cursor: pointer;">
                        <input style="width: 80px;border: none;height:25px;" id="${
            targetObj.prefixCls
            }_${id}_end" type="number" class="go-number-input form-control padding-l-bs">
                         ${goRangeClearInputIcon(targetObj, id, "end")} 
                     </div>
                </div> `;
    },
    /**
     * 查询form下的 数字 分最大数字和最小数字
     * @param label
     * @param id
     * @param editorType
     * @param targetObj
     * @returns {string}
     */
    getQueryHtml: function ({label, id, editorType}, targetObj) {
        return `<div class="row  go-form-row flex-div">
                <div class="go-label" style="${_getElStyle(targetObj)}">${label}：</div> 
                <div class="go-content clearfix" style="${_getInputElStyle(targetObj)}">
                         <div class="input-group pull-left" style="cursor: pointer;width:49%;margin-right:4px;">
                            <input id="${targetObj.prefixCls}_${id}_start" type="number" class="go-number-input form-control padding-l-bs"> 
                              ${goRangeClearInputIcon(targetObj, id, "start")} 
                         </div>
                         <div class="input-group  pull-left" style="cursor: pointer;width:49%;">
                            <input id="${targetObj.prefixCls}_${id}_end" type="number" class="go-number-input form-control padding-l-bs">
                              ${goRangeClearInputIcon(targetObj, id, "end")} 
                         </div>
                    </div> 
            </div>`;
    },
    clearData(item, formType, targetObj) {
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        $("#" + inputElId).val("");
    },
    /**
     * 初始化提交数据
     * @param item
     * @param targetObj 目标form对象
     * @param backJson 返回的数据
     * @param formType 表单类型
     */
    getSubmitData: function (
        item,
        targetObj,
        backJson,
        formType
    ) {
        if (formType === "query" || formType === "singleQuery") {
            this.getQuerySubmitData(item, targetObj, backJson);
        } else {
            this.getEditorSubmitData(item, targetObj, backJson);
        }
    },
    getRealValue(value) {
        return value || " ";
    },
    getQuerySubmitData: function (item, targetObj, backJson) {
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        if ($("#" + inputElId + "_start").get(0) != null) {
            //开始时间
            backJson[item["id"] + "_ge_number"] = $("#" + inputElId + "_start").val();
            //结束时间
            backJson[item["id"] + "_le_number"] = $("#" + inputElId + "_end").val();
        }
    },
    getEditorSubmitData: function (item, targetObj, backJson) {
        //时间
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        backJson[item["id"]] = $("#" + inputElId).val();
    },
    setValue(prop, propValue, item, targetObj) {
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        $("#" + inputElId).val(propValue);
        if (AssertUtils.isNotEmpty(propValue)) {
            _showClearIcon(inputElId);
        }
    },
    initCtlEvent: function (
        parentObj,
        inputWidth,
        targetObj,
        vueObj
    ) {
        $(parentObj)
            .find(".go-number-input")
            .on("input", function () {
                let val = $(this).val();
                let inputElId = $(this).attr("id");
                if (!AssertUtils.isNumber(val)) {
                    $(`#${inputElId}`)
                        .closest(".go-form-row")
                        .find(".error-info").show()
                        .attr("msg", `输入的不是有效数字！`);
                    _showValidationError(inputElId);
                    return void 0;
                }

                let maxlength=$(this).attr("maxlength");

                if ((val + "").length > 0) {
                    _removeValidationInfo(inputElId);
                    //隐藏以前的错误提示
                    $(`#${inputElId}`)
                        .closest(".go-form-row")
                        .find(".error-info")
                        .hide();

                    if((val + "").length > maxlength){
                        $(`#${inputElId}`)
                            .closest(".go-form-row")
                            .find(".error-info").show()
                            .attr("msg", `输入的值大于了最大长度限制！`);
                        $(this).val((val+"").substring(0,maxlength));
                        _showValidationError(inputElId);
                    }
                }
            });

        //普通输入框的change事件
        $(parentObj)
            .find(".go-number-input")
            .on("change", function () {
                let elId = $(this).attr("id");

                elId = elId.replaceAll(targetObj.prefixCls + "_", "");
                if (vueObj != null) {
                    vueObj.$emit("change", {
                        value: $(this).val(),
                        id: elId,
                        elObj: $(this)
                    });
                }
            });
    }
};

export default NumberInputCtl;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goForm/components/js-number.js